import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { ChoiceSettingPage } from './choice-setting.page';
import { TranslateModule } from '@ngx-translate/core';

const routes: Routes = [
    {
        path: 'choice-setting',
        component: ChoiceSettingPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        TranslateModule
    ],
    declarations: [ChoiceSettingPage],
    exports: [ChoiceSettingPage]
})
export class ChoiceSettingPageModule {}
